import React, { useMemo } from 'react';
import { Skeleton } from 'primereact/skeleton';
import WallPreviewRenderer from './WallPreviewRenderer';
import { buildTemplatePreviewPayload } from './buildTemplatePreviewPayload';
import { useGetTemplate } from '../../../../queries/signageTemplates';

/**
 * Smart Template Engine — Preview System (Phase 2A helper).
 *
 * Resolves a playlist template item (only a `template_instance_id`) into a live
 * `WallPreviewRenderer` by fetching the full instance (+ menu) and assembling the
 * payload client-side. Used by the playlist player (2A) and simulator (4). Live
 * preview (3A) skips this — it gets the resolved `template` block straight from RTDB.
 */
export default function TemplateItemPreview({ instanceId, grid, themes = [], defaultZones = {}, resolvePhoto = () => null, maxWidth = 520 }) {
  const { data: instance, isLoading } = useGetTemplate(instanceId, !!instanceId);

  const template = useMemo(() => {
    if (!instance) return null;
    return buildTemplatePreviewPayload({
      instance: {
        type: instance.type,
        theme_key: instance.theme_key,
        screen_assignments: instance.screen_assignments,
        settings: instance.settings,
      },
      sections: instance.menu?.sections ?? [],
      theme: themes.find((th) => th.key === instance.theme_key) || {},
      defaultZones,
      currency: instance.menu?.currency || 'SAR',
      resolvePhoto,
    });
  }, [instance, themes, defaultZones, resolvePhoto]);

  if (isLoading || !template) return <Skeleton width={`${maxWidth}px`} height={`${maxWidth * 0.6}px`} />;
  return <WallPreviewRenderer template={template} grid={grid} maxWidth={maxWidth} />;
}
